import React from 'react';
import './styles/Input.css';

export const Input = React.forwardRef(
  ({
    className = '',
    error,
    help,
    label,
    required,
    icon: Icon,
    variant = 'outlined',
    size = 'md',
    fullWidth = false,
    disabled = false,
    ...props
  }, ref) => {
    const classes = `input input-${variant} input-${size} ${fullWidth ? 'input-full-width' : ''} ${error ? 'input-error' : ''} ${className}`;

    return (
      <div className="input-wrapper">
        {label && (
          <label className="input-label">
            {label}
            {required && <span className="input-required">*</span>}
          </label>
        )}
        <div className="input-container">
          {Icon && <Icon className="input-icon" />}
          <input
            className={classes}
            ref={ref}
            disabled={disabled}
            {...props}
          />
        </div>
        {error && <span className="input-error-message">{error}</span>}
        {help && !error && <span className="input-help-text">{help}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export const Textarea = React.forwardRef(
  ({
    className = '',
    error,
    help,
    label,
    required,
    variant = 'outlined',
    rows = 4,
    fullWidth = true,
    disabled = false,
    ...props
  }, ref) => {
    const classes = `textarea textarea-${variant} ${fullWidth ? 'textarea-full-width' : ''} ${error ? 'textarea-error' : ''} ${className}`;

    return (
      <div className="textarea-wrapper">
        {label && (
          <label className="textarea-label">
            {label}
            {required && <span className="textarea-required">*</span>}
          </label>
        )}
        <textarea
          className={classes}
          ref={ref}
          rows={rows}
          disabled={disabled}
          {...props}
        />
        {error && <span className="textarea-error-message">{error}</span>}
        {help && !error && <span className="textarea-help-text">{help}</span>}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Input;
